import { QueryParams } from "@ui/navigation/routes";
import { useCallback, useMemo } from "react";
import { useLocation } from "react-router";

interface UseHistoryHook<T> {
	updateHistory: (queryParam: T) => void;
	cleanHistory: () => void;
	isInitialLocation: boolean;
}

const INITIAL_LOCATION = "default";

export function useHistory<R extends keyof QueryParams>(): UseHistoryHook<Partial<QueryParams[R]>> {
	const location = useLocation();

	const updateHistory = useCallback(
		(queryParam: Partial<QueryParams[R]>) => {
			const currentParams: Record<string, string> = {};
			new URLSearchParams(location.search).forEach((value, key) => Object.assign(currentParams, { [key]: value }));
			const newQueryParams = new URLSearchParams({
				...currentParams,
				...queryParam,
			}).toString();
			window.history.replaceState({}, "", "?" + newQueryParams);
		},
		[location.search],
	);

	const cleanHistory = useCallback(() => {
		window.history.replaceState({}, "", "?");
	}, []);

	const isInitialLocation = useMemo(() => location.key === INITIAL_LOCATION, [location.key]);

	return { updateHistory, cleanHistory, isInitialLocation };
}
